import React, { useEffect, useMemo, useState } from 'react'
import { getStatusCounts, getTabsFromSubtasks, getDesignationTabsFromSubtasks } from '../../../../utils/taskUtils';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { getSingleTask } from '../../../../redux/TaskReducer/action';
import './SubtaskVerification.css';
import { SubtaskRenderer } from './SubtaskScreens/SubtaskRenderer';

// QMS Tab — Query Visibility Across RO, BM and BCM (PRD §6): the selected designation
// filter persists for the current browser tab/session. Per-viewer convenience only —
// never read back by the server, so a blocked/cleared sessionStorage just falls back to
// "ALL".
const DESIGNATION_STORAGE_KEY = 'qms_designation_tab';

const readStoredDesignation = () => {
  try {
    return sessionStorage.getItem(DESIGNATION_STORAGE_KEY) || 'ALL';
  } catch {
    return 'ALL';
  }
};

const SubtaskVerification = () => {

  const { singleTask } = useSelector((store) => {
    return {
      singleTask: store.TasksReducer.singleTask
    }
  });

  const subTasks = useMemo(() => singleTask?.data?.sub_tasks || [], [singleTask?.data]);

  const { taskId, activeTab } = useParams();
  const dispatch = useDispatch();

  const tabs = useMemo(() => getTabsFromSubtasks(subTasks), [subTasks]);
  // const [activeTab, setActiveTab] = useState(null);

  // const counts = useMemo(
  //   () => getStatusCounts(subTasks),
  //   [subTasks]
  // );

  // Designation filter — My Designation is meaningless for an Admin Panel user (they
  // aren't RO/BM/BCM themselves), so this is RO / BM / BCM / All, scoped to whichever
  // designations actually have a sub-task on this task.
  const [designationTab, setDesignationTab] = useState(readStoredDesignation);
  const designationTabs = useMemo(() => getDesignationTabsFromSubtasks(subTasks), [subTasks]);

  const handleDesignationTabChange = (code) => {
    setDesignationTab(code);
    try {
      sessionStorage.setItem(DESIGNATION_STORAGE_KEY, code);
    } catch {
      // ignore — per-viewer convenience only
    }
  };

  const designationFilteredSubtasks = useMemo(
    () =>
      designationTab === 'ALL'
        ? subTasks
        : subTasks.filter(st => st.assignee?.designation?.toUpperCase() === designationTab),
    [subTasks, designationTab]
  );

  const designationStatusCounts = useMemo(
    () => getStatusCounts(designationFilteredSubtasks),
    [designationFilteredSubtasks]
  );

  const visibleSubtasks = useMemo(
    () =>
      designationFilteredSubtasks.filter(
        st => st.task_type.type_code === activeTab
      ),
    [designationFilteredSubtasks, activeTab]
  );

  // useEffect(() => {
  //   if (tabs.length && !activeTab) {
  //     setActiveTab(tabs[0].code);
  //   }
  // }, [tabs, activeTab]);

  useEffect(() => {
    dispatch(getSingleTask(taskId));
  }, [taskId, dispatch]);

  if(subTasks.length === 0){
    return (
      <div 
        style={{
          width: "100%",
          height: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "white",
          borderRadius: "20px",
          marginTop: "10px"
        }}
      >
        <p>No subtasks found</p>
      </div>
    )
  }

  return (
    <div className='subtask-container'>
      {/* Tabs */}
      {/* <div className="subtask-tabs">
        <div className="tabs">
          {tabs.map(tab => (
            <button
              key={tab.code}
              className={`tab ${activeTab === tab.code ? "active" : ""}`}
              onClick={() => setActiveTab(tab.code)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="status-summary">
          <span>Pending: {counts.pending}</span>
          <span className="approved">Approved: {counts.approved}</span>
          <span className="rejected">Rejected: {counts.rejected}</span>
        </div>
      </div> */}

      {/* QMS designation tabs — RO / BM / BCM / All, only shown when more than one
          designation actually has a sub-task on this task. */}
      {designationTabs.length > 1 && (
        <div className="designation-tabs">
          <div className="tabs">
            <button
              className={`tab ${designationTab === 'ALL' ? 'active' : ''}`}
              onClick={() => handleDesignationTabChange('ALL')}
            >
              All
            </button>
            {designationTabs.map(code => (
              <button
                key={code}
                className={`tab ${designationTab === code ? 'active' : ''}`}
                onClick={() => handleDesignationTabChange(code)}
              >
                {code}
              </button>
            ))}
          </div>

          <div className="status-summary">
            <span>Pending: {designationStatusCounts.pending}</span>
            <span>Under Review: {designationStatusCounts.underReview}</span>
            <span className="approved">Approved: {designationStatusCounts.approved}</span>
            <span className="rejected">Rejected: {designationStatusCounts.rejected}</span>
          </div>
        </div>
      )}

      {/* Content */}
      {visibleSubtasks.length === 0 ? (
        <div className="designation-empty-state">
          <p>
            {designationTab === 'ALL'
              ? 'No sub-tasks found for this section.'
              : `No queries assigned to the ${designationTab} on this task.`}
          </p>
        </div>
      ) : (
        <div className="subtask-content">
          {visibleSubtasks?.map(st => (
            <SubtaskRenderer key={st.sub_task_id} subtask={st} />
          ))}
        </div>
      )}
    </div>
  );
}

export default SubtaskVerification